import React from 'react'
import { Container } from 'semantic-ui-react'
import ModuleMenu, { MenuProps } from './ModuleMenu'

const DeviceControls: React.FC<MenuProps> = ({ zoomIn, zoomOut, getDevice, showEntireDevice, closeContextMenu }: MenuProps) => (
  <Container textAlign='center'>
    <div style={{ margin: '3.5rem' }}>
      <ModuleMenu
        closeContextMenu={closeContextMenu}
        zoomIn={zoomIn}
        zoomOut={zoomOut}
        getDevice={getDevice}
        showEntireDevice={showEntireDevice}
      />
    </div>
  </Container>
)

export default DeviceControls
